import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e8a935e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vmcms" }
const _hoisted_2 = { class: "powerful_code-main" }
const _hoisted_3 = {
  key: 0,
  class: "config-title-bar"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "config-title-label" }, "标题：", -1))
const _hoisted_5 = {
  key: 1,
  class: "editor-tools"
}
const _hoisted_6 = { class: "tool-section" }
const _hoisted_7 = { class: "preview-toggle" }
const _hoisted_8 = {
  class: "page-phone",
  style: {"background":"rgb(255, 255, 255)"}
}
const _hoisted_9 = { class: "page-render page" }
const _hoisted_10 = {
  key: 0,
  class: "item-controls"
}
const _hoisted_11 = ["onClick", "disabled"]
const _hoisted_12 = ["onClick", "disabled"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "rich-text-box-wrapper"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "rich-text-toolbar"
}
const _hoisted_17 = ["onUpdate:modelValue", "onChange"]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<option value=\"12px\" data-v-4e8a935e>12px</option><option value=\"14px\" data-v-4e8a935e>14px</option><option value=\"16px\" selected data-v-4e8a935e>16px</option><option value=\"18px\" data-v-4e8a935e>18px</option><option value=\"20px\" data-v-4e8a935e>20px</option><option value=\"24px\" data-v-4e8a935e>24px</option><option value=\"28px\" data-v-4e8a935e>28px</option><option value=\"32px\" data-v-4e8a935e>32px</option>", 8)
const _hoisted_26 = [
  _hoisted_18
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "B", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "I", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "U", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "color-picker-wrapper" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "color-picker-popup"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onUpdate:modelValue", "onChange"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "left" }, "左对齐", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "center" }, "居中", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "right" }, "右对齐", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "justify" }, "两端对齐", -1))
const _hoisted_45 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = ["onUpdate:modelValue", "onChange"]
const _hoisted_47 = ["onFocus", "onInput", "onCompositionend"]
const _hoisted_48 = {
  key: 2,
  class: "banner-img"
}
const _hoisted_49 = {
  key: 0,
  class: "rich-text-toolbar"
}
const _hoisted_50 = { class: "url-input-group" }
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onChange"]
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "无边框", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1px solid red" }, "红色边框", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1px solid blue" }, "蓝色边框", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1px dashed gray" }, "灰色虚线", -1))
const _hoisted_60 = [
  _hoisted_56,
  _hoisted_57,
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = ["src", "alt", "onClick"]
const _hoisted_62 = { key: 3 }
const _hoisted_63 = {
  key: 0,
  class: "rich-text-toolbar button-toolbar"
}
const _hoisted_64 = { class: "button-input-group" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "按钮文本:", -1))
const _hoisted_66 = { class: "url-input-group" }
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "button-input-group" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "跳转链接:", -1))
const _hoisted_71 = { class: "url-input-group" }
const _hoisted_72 = ["onUpdate:modelValue"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "button-style-group" }
const _hoisted_75 = { class: "style-control" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "背景颜色:", -1))
const _hoisted_77 = ["onUpdate:modelValue"]
const _hoisted_78 = { class: "style-control" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "文本颜色:", -1))
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { key: 4 }
const _hoisted_83 = {
  key: 0,
  class: "rich-text-toolbar"
}
const _hoisted_84 = { class: "url-input-group" }
const _hoisted_85 = ["onUpdate:modelValue"]
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "url-input-group" }
const _hoisted_88 = ["onUpdate:modelValue"]
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "style-control-group" }
const _hoisted_91 = { class: "style-control" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "颜色: ", -1))
const _hoisted_93 = ["onUpdate:modelValue"]
const _hoisted_94 = { class: "style-control" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "下划线: ", -1))
const _hoisted_96 = ["onUpdate:modelValue"]
const _hoisted_97 = { class: "link_box" }
const _hoisted_98 = ["href"]
const _hoisted_99 = {
  key: 0,
  class: "save-load-controls"
}
const _hoisted_100 = {
  key: 0,
  class: "preview-controls"
}
const _hoisted_101 = { key: 0 }
const _hoisted_102 = {
  key: 1,
  class: "published-url-section"
}
const _hoisted_103 = { class: "url-display" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.editMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageTitle) = $event)),
              class: "config-title-input",
              placeholder: "请输入页面标题，仅备注用"
            }, null, 512), [
              [_vModelText, _ctx.pageTitle]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.editMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addTextBlock && _ctx.addTextBlock(...args)))
              }, "添加文字"),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addImageBlock && _ctx.addImageBlock(...args)))
              }, "添加图片"),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addButtonBlock && _ctx.addButtonBlock(...args)))
              }, "添加按钮"),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addLinkBlock && _ctx.addLinkBlock(...args)))
              }, "添加链接")
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleEditMode && _ctx.toggleEditMode(...args)))
              }, "预览页面")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["page-app", { active: !_ctx.editMode }])
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItems, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.uid || index,
                class: _normalizeClass(["content-item", { 'editing-item': _ctx.editMode }])
              }, [
                (_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.moveUp(index)),
                        disabled: index === 0
                      }, " 上移 ", 8, _hoisted_11),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.moveDown(index)),
                        disabled: index === _ctx.contentItems.length - 1
                      }, " 下移 ", 8, _hoisted_12),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.removeItem(item.uid, index))
                      }, "删除", 8, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'text')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (!_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["copy-text-btn", { 'copied': _ctx.copiedTextBlocks[index] }]),
                            onClick: ($event: any) => (_ctx.copyTextContent(index, item)),
                            title: "复制文字内容"
                          }, " 点击复制 ", 10, _hoisted_15))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": ($event: any) => ((item.style.fontSize) = $event),
                              onChange: ($event: any) => (
                      _ctx.applyTextStyle(index, 'fontSize', $event.target.value)
                    )
                            }, _hoisted_26, 40, _hoisted_17), [
                              [_vModelSelect, item.style.fontSize]
                            ]),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.toggleTextStyle(index, 'bold')),
                              class: _normalizeClass({ active: item.style.fontWeight === 'bold' }),
                              title: "加粗"
                            }, _hoisted_29, 10, _hoisted_27),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.toggleTextStyle(index, 'italic')),
                              class: _normalizeClass({ active: item.style.fontStyle === 'italic' }),
                              title: "斜体"
                            }, _hoisted_32, 10, _hoisted_30),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.toggleTextStyle(index, 'underline')),
                              class: _normalizeClass({
                      active: item.style.textDecoration === 'underline',
                    }),
                              title: "下划线"
                            }, _hoisted_35, 10, _hoisted_33),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("button", {
                                class: "color-picker-button",
                                onClick: ($event: any) => (_ctx.toggleColorPicker(index)),
                                style: _normalizeStyle({
                        backgroundColor: item.style.color || '#000000',
                      }),
                                title: "文字颜色"
                              }, null, 12, _hoisted_37),
                              (_ctx.activeColorPicker === index)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.predefinedColors, (color) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: color,
                                        class: "color-option",
                                        style: _normalizeStyle({ backgroundColor: color }),
                                        onClick: ($event: any) => (_ctx.applyTextColor(index, color))
                                      }, null, 12, _hoisted_39))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": ($event: any) => ((item.style.textAlign) = $event),
                              onChange: ($event: any) => (
                      _ctx.applyTextStyle(index, 'textAlign', $event.target.value)
                    )
                            }, _hoisted_45, 40, _hoisted_40), [
                              [_vModelSelect, item.style.textAlign]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": ($event: any) => ((item.style.lineHeight) = $event),
                              min: "1",
                              max: "3",
                              step: "0.1",
                              onChange: ($event: any) => (
                      _ctx.applyTextStyle(index, 'lineHeight', $event.target.value)
                    ),
                              title: "行高"
                            }, null, 40, _hoisted_46), [
                              [
                                _vModelText,
                                item.style.lineHeight,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        ref_for: true,
                        ref: (el) => _ctx.setEditableRef(el, index),
                        class: "editor-content-view",
                        style: _normalizeStyle(_ctx.getTextStyle(item.style)),
                        contenteditable: "true",
                        onFocus: ($event: any) => (_ctx.setActiveTextIndex(index)),
                        onInput: (e) => _ctx.updateTextContent(index, e),
                        onMouseup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveSelection && _ctx.saveSelection(...args))),
                        onKeyup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveSelection && _ctx.saveSelection(...args))),
                        onCompositionstart: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleCompositionStart && _ctx.handleCompositionStart(...args))),
                        onCompositionend: (e) => _ctx.handleCompositionEnd(e, index)
                      }, null, 44, _hoisted_47)
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'image')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((item.src) = $event),
                                placeholder: "输入图片URL",
                                class: "large-input"
                              }, null, 8, _hoisted_51), [
                                [_vModelText, item.src]
                              ]),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (item.src = ''),
                                class: "clear-button"
                              }, "×", 8, _hoisted_52),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.triggerImageUpload(index)),
                                class: "upload-button"
                              }, "上传图片", 8, _hoisted_53),
                              _createElementVNode("input", {
                                type: "file",
                                ref_for: true,
                                ref: (el) => _ctx.setFileInputRef(el as HTMLInputElement, index),
                                onChange: ($event: any) => (_ctx.handleImageUpload($event, index)),
                                accept: "image/*",
                                style: {"display":"none"}
                              }, null, 40, _hoisted_54)
                            ]),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": ($event: any) => ((item.style.border) = $event)
                            }, _hoisted_60, 8, _hoisted_55), [
                              [_vModelSelect, item.style.border]
                            ]),
                            (_ctx.uploadStatus[index])
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["upload-status", _ctx.uploadStatus[index].type])
                                }, _toDisplayString(_ctx.uploadStatus[index].message), 3))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("img", {
                        src: item.src,
                        alt: item.alt || '图片',
                        style: _normalizeStyle(item.style),
                        onClick: ($event: any) => (_ctx.editMode && _ctx.triggerImageUpload(index))
                      }, null, 12, _hoisted_61)
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'button')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _hoisted_65,
                              _createElementVNode("div", _hoisted_66, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((item.text) = $event),
                                  placeholder: "请输入按钮文本",
                                  class: "large-input"
                                }, null, 8, _hoisted_67), [
                                  [_vModelText, item.text]
                                ]),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (item.text = ''),
                                  class: "clear-button"
                                }, "×", 8, _hoisted_68)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _hoisted_70,
                              _createElementVNode("div", _hoisted_71, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((item.link) = $event),
                                  placeholder: "请输入跳转链接",
                                  class: "large-input"
                                }, null, 8, _hoisted_72), [
                                  [_vModelText, item.link]
                                ]),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (item.link = ''),
                                  class: "clear-button"
                                }, "×", 8, _hoisted_73)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                _hoisted_76,
                                _withDirectives(_createElementVNode("input", {
                                  type: "color",
                                  "onUpdate:modelValue": ($event: any) => ((item.style.background) = $event)
                                }, null, 8, _hoisted_77), [
                                  [_vModelText, item.style.background]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_78, [
                                _hoisted_79,
                                _withDirectives(_createElementVNode("input", {
                                  type: "color",
                                  "onUpdate:modelValue": ($event: any) => ((item.style.color) = $event)
                                }, null, 8, _hoisted_80), [
                                  [_vModelText, item.style.color]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "coppy_button",
                        style: _normalizeStyle({
                    background:
                      item.style.background ||
                      'linear-gradient(90deg, rgb(251, 136, 77) 0%, rgb(247, 62, 40) 100%)',
                    color: item.style.color || '#ffffff',
                  }),
                        onClick: ($event: any) => (_ctx.handleButtonClick(item))
                      }, _toDisplayString(item.text), 13, _hoisted_81)
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'link')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((item.text) = $event),
                                placeholder: "链接文本（留空则显示URL）",
                                class: "large-input"
                              }, null, 8, _hoisted_85), [
                                [_vModelText, item.text]
                              ]),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (item.text = ''),
                                class: "clear-button"
                              }, "×", 8, _hoisted_86)
                            ]),
                            _createElementVNode("div", _hoisted_87, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((item.url) = $event),
                                placeholder: "链接URL",
                                class: "large-input"
                              }, null, 8, _hoisted_88), [
                                [_vModelText, item.url]
                              ]),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (item.url = ''),
                                class: "clear-button"
                              }, "×", 8, _hoisted_89)
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("div", _hoisted_91, [
                                _hoisted_92,
                                _withDirectives(_createElementVNode("input", {
                                  type: "color",
                                  "onUpdate:modelValue": ($event: any) => ((item.style.color) = $event)
                                }, null, 8, _hoisted_93), [
                                  [_vModelText, item.style.color]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_94, [
                                _hoisted_95,
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((item.style.textDecoration) = $event)
                                }, null, 8, _hoisted_96), [
                                  [_vModelCheckbox, item.style.textDecoration]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("a", {
                          href: item.url,
                          target: "_blank",
                          style: _normalizeStyle({
                    color: item.style.color,
                    textDecoration: item.style.textDecoration
                      ? 'underline'
                      : 'none',
                  })
                        }, _toDisplayString(item.text && item.text.trim() ? item.text : item.url), 13, _hoisted_98)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                  _createElementVNode("button", {
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveContent && _ctx.saveContent(...args)))
                  }, "保存本地"),
                  _createElementVNode("button", {
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.loadContent && _ctx.loadContent(...args)))
                  }, "加载本地"),
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.resetContent && _ctx.resetContent(...args)))
                  }, "重置内容"),
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.goList && _ctx.goList(...args))),
                    class: "back-list-btn"
                  }, "返回列表")
                ]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.editMode )
            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                (!_ctx.publishedUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                      _createElementVNode("button", {
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.toggleEditMode && _ctx.toggleEditMode(...args)))
                      }, "返回编辑"),
                      _createElementVNode("button", {
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.publishContent && _ctx.publishContent(...args))),
                        class: "publish-button"
                      }, "提交发布"),
                      _createElementVNode("button", {
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.goList && _ctx.goList(...args))),
                        class: "back-list-btn"
                      }, "返回列表")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.publishedUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                      _createElementVNode("div", {
                        class: "url-display-box",
                        ref: "urlDisplay"
                      }, _toDisplayString(_ctx.publishedUrl), 513),
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("button", {
                          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.copyUrl && _ctx.copyUrl(...args))),
                          class: "copy-button"
                        }, "复制链接"),
                        _createElementVNode("button", {
                          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.goList && _ctx.goList(...args))),
                          class: "copy-button"
                        }, "返回列表")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}